<template>
  <div class="loader">
    <div class="loader-header">
      <GFMP :wrapper-styles="{ width: '90%' }" :styles="{ ...fmpStyles.rounded }" />
    </div>
    <ReviewCardLoader v-for="i in 3" :key="i" />
  </div>
</template>

<script>
export default {
  name: 'review-card-list-loader',
  components: { ReviewCardLoader: () => import('./review-card-loader') },
  data() {
    return {
      fmpStyles: {
        rounded: {
          borderRadius: '8px',
          height: '12px',
        },
        circle: {
          borderRadius: '50%',
          height: '12px',
        },
      },
    };
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/sass/_mixin-revamp.scss';

.loader {
  display: flex;
  flex-direction: column;
  gap: 32px;
  background-color: white;

  &-header {
    display: flex;
    justify-content: space-between;

    &-start {
      width: 60%;
    }

    &-end {
      width: 5%;
    }
  }
}
</style>
